import React from 'react';
import { motion } from 'framer-motion';
import { AGREEXA_APP_URL } from '../lib/links';
import { ShoppingBag, ExternalLink, ShieldCheck } from 'lucide-react';
const products = [{
  name: 'Pro Woodworking Kit',
  category: 'Tools',
  price: '$249.99',
  image: 'https://images.unsplash.com/photo-1572981779307-38b8cabb2407?q=80&w=600&auto=format&fit=crop'
}, {
  name: 'Premium Walnut Lumber',
  category: 'Materials',
  price: '$85.00',
  image: 'https://images.unsplash.com/photo-1520106680486-778643194519?q=80&w=600&auto=format&fit=crop'
}, {
  name: 'Arduino Starter Bundle',
  category: 'Electronics',
  price: '$45.50',
  image: 'https://images.unsplash.com/photo-1553406830-ef2513450d76?q=80&w=600&auto=format&fit=crop'
}, {
  name: 'Heavy Duty Safety Goggles',
  category: 'Safety',
  price: '$24.99',
  image: 'https://images.unsplash.com/photo-1588612413410-0921e330a112?q=80&w=600&auto=format&fit=crop'
}];
export function ShoppingSection() {
  return <section className="py-24 bg-white dark:bg-navy-800 border-y border-gray-100 dark:border-navy-700" data-id="element-313">
      <div className="max-w-7xl mx-auto px-6" data-id="element-314">
        <div className="flex flex-col md:flex-row items-end justify-between mb-12 gap-6" data-id="element-315">
          <div className="max-w-2xl" data-id="element-316">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-orange-100 dark:bg-orange-500/10 text-orange-600 dark:text-orange-400 text-sm font-semibold mb-6" data-id="element-317">
              <ShoppingBag size={16} data-id="element-318" /> Recommended Gear
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-navy-900 dark:text-white mb-4" data-id="element-319">
              Everything You Need.
            </h2>
            <p className="text-lg text-navy-700 dark:text-gray-400" data-id="element-320">
              Every project comes with curated, affiliate-ready shopping lists
              for tools, materials, and safety equipment.
            </p>
          </div>
          <div className="flex items-center gap-2 text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-321">
            <ShieldCheck size={18} className="text-forest-500" data-id="element-322" /> Verified
            Products
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-323">
          {products.map((product, index) => <motion.div key={product.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} onClick={() => {
          window.location.href = AGREEXA_APP_URL;
        }} className="group rounded-2xl glass-card overflow-hidden flex flex-col cursor-pointer" data-id="element-324">
              <div className="relative h-48 overflow-hidden bg-gray-100 dark:bg-navy-900" data-id="element-325">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-326" />
                <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-white/90 dark:bg-navy-900/90 backdrop-blur-sm text-xs font-bold text-navy-900 dark:text-white uppercase tracking-wider" data-id="element-327">
                  {product.category}
                </div>
              </div>
              <div className="p-5 flex flex-col flex-grow" data-id="element-328">
                <h3 className="font-bold text-navy-900 dark:text-white mb-2 line-clamp-2" data-id="element-329">
                  {product.name}
                </h3>
                <div className="mt-auto pt-4 flex items-center justify-between" data-id="element-330">
                  <span className="font-semibold text-lg text-navy-900 dark:text-white" data-id="element-331">
                    {product.price}
                  </span>
                  <button onClick={e => {
                e.stopPropagation();
                window.location.href = AGREEXA_APP_URL;
              }} className="flex items-center gap-1.5 text-sm font-medium text-orange-500 hover:text-orange-600 transition-colors" data-id="element-332">
                    View <ExternalLink size={14} data-id="element-333" />
                  </button>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}